import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/terms")({
  component: TermsRoute,
})

function TermsRoute() {
  return (
    <main className="min-h-[100dvh] bg-[#18191b] px-[24px] py-[72px] font-sans text-[#f1f7fe]">
      <article className="mx-auto max-w-[720px]">
        <a
          href="/login"
          className="text-[#7aa7ff] text-[14px]"
        >
          Back to login
        </a>
        <h1 className="mt-[32px] text-[36px] leading-[1.15]">Terms</h1>
        <p className="mt-[16px] text-[16px] text-[rgba(241,247,254,0.72)] leading-[1.7]">
          Playbrain CMS is an internal dashboard for authorized Playbrain team members and approved
          collaborators. Access is granted by administrators and may be changed or revoked when needed to
          protect Playbrain systems and content.
        </p>
        <p className="mt-[16px] text-[16px] text-[rgba(241,247,254,0.72)] leading-[1.7]">
          By using the dashboard, you agree to keep account credentials private, use the service only for
          approved Playbrain work, and avoid sharing unpublished content outside authorized teams.
        </p>
      </article>
    </main>
  )
}
